import { seoRoutes } from './seo';
import { settingsRoutes } from './settings';

export default {
  seo: seoRoutes,
  settings: settingsRoutes,
};
